module.exports = __webpack_public_path__ + "img/about_logistic.696fe62a.jpg";